import { Checkbox } from '@/components/DesignLibrary/Atoms';

type Props = {
  isInList: boolean;
  isEditableInTableView: boolean;
  onChange: (newValue: boolean) => void;
};

const IsEditableInTableView: React.FC<Props> = ({ isEditableInTableView, onChange, isInList }) => {
  if (!isInList) {
    return null;
  }

  return (
    <Checkbox
      label="Is editable in table view"
      isChecked={isEditableInTableView}
      onChange={onChange}
      size="sm"
    />
  );
};

export default IsEditableInTableView;